import React, { Component } from 'react';
import { Switch,Route,Redirect } from 'react-router-dom';
import MainLayout from '../main_layout';
import SideMenu from '../../components/side_menu';
import { getBreadcrumb } from '../../util/ui_util';
import SourceSetting from './sources';
import PluginsSetting from './plugins';
import ReconcilerSettings from './reconciler_process';
import CleanReprocessSetting from './clean_reprocess_setting';
// import FetcherConfigAddEdit from './plugins/fetcher_config_addedit';
import UserSetting from './users/index';
import DataTypeSetting from './data_types/index';
import DataRepositorySetting from './repository';
import LogsSetting from './logs/index';
import ApplicationSetting from './app_settings';
import CroneSetting from './crone_configs/index';
import ImportExportSetting from './import_export_setting';
import ReferencesSetting from './references_setting';
import GroupSetting from './groups/index';
import TableSetting from './tables/index';
import MakerCheckerSetting from './maker_checker/index'
import HookSetting from './hooks';

class SettingPage extends Component {
  constructor(props) {
    super(props)

    this.state = {

    }
    
  }

  render() {
    var pathName=this.props.location.pathname+this.props.location.search;

    return (
      <MainLayout
        backgroundColor={"#00a5d6"}
        onRef={(ref) => {
          // console.log("changing reg", ref);
          window.slider_main = ref
      }}
        sliderContent={<SideMenu
            menuKey={pathName}
            item={[
              {
                type:'main',
                title:"Groups",
                key:'groups',
                url:'settings/groups'
              },
              // {
              //   type:"main",
              //   title:"Datatypes",
              //   key:'data-type',
              //   url:'settings/datatype'
              // },
              {
                type:"main",
                title:"Data Repository",
                key:'data-repository',
                url:'settings/data-repository'
              },
              // {
              //   type:"main",
              //   title:"Sources",
              //   key:'sources',
              //   url:'settings/sources'
              // },
              {
                type:"main",
                title:"Tables",
                key:'tables',
                url:'settings/tables'
              },
              {
                type:"main",
                title:"Plugins",
                key:'plugins',
                url:'settings/plugins'
              },
              // {
              //   type:"main",
              //   title:"Reconcilers",
              //   key:'reconcilers',
              //   url:'settings/reconcilers-group'
              // },
              {
                type:"main",
                title:"References",
                key:'references',
                url:'settings/references'
              },
              {
                type:"main",
                title:"Users",
                key:'users',
                url:'settings/users'
              },
              {
                type:"expandable",
                title:"Logs",
                key:'logs',
                title_url:'/settings/logs',
                childItem:[
                  {
                    type:'secondary',
                    url:'settings/logs/general',
                    key:'general',
                    title:'General Logs'
                },
                {
                  type:'secondary',
                  url:'settings/logs/users',
                  key:'users',
                  title:'User Logs'
                },
                {
                  type:'secondary',
                  url:'settings/logs/engine',
                  key:'engine',
                  title:'Engine Logs'
                },
                {
                  type:'secondary',
                  url:'settings/logs/cron',
                  key:'cron',
                  title:'Cron Logs'
                },
                
                ]
              },
              {
                type:"main",
                title:"Cron Configs",
                key:'cron_config',
                url:'settings/cron'
              },
              {
                type: "main",
                title: "Hooks",
                key: 'hooks',
                url: 'settings/hooks'
            },
              {
                type:"main",
                title:"Maker Checker",
                key:'maker-checker',
                url:'settings/maker-checker'
              },
              {
                type:"main",
                title:"App Settings",
                key:'app_settings',
                url:'settings/app-settings'
              },
              {
                type:'main',
                title:'Import/Export',
                key:'import-export',
                url:'settings/import-export'
              },
              {
                type:'main',
                title:'Clean/Reprocess',
                key:'clean-reprocess',
                url:'settings/clean-reprocess'
              }
           ]}
           />}
        pageTitle={"Settings"}
        // tags={tags}
        pageRoutes={{routes:getBreadcrumb(this.props.location.pathname)}}
        mainContent={<Switch>
                    <Route  path='/settings/groups' component={GroupSetting}/>

          {/* <Route  path='/settings/sources' component={SourceSetting}/> */}
          <Route  path='/settings/tables' component={TableSetting}/>
          <Route  path='/settings/plugins' component={PluginsSetting}/>
          <Route  path='/settings/reconcilers-group' component={ReconcilerSettings}/>
          <Route  path='/settings/users' component={UserSetting}/>
          {/* <Route  path='/settings/datatype' component={DataTypeSetting}/> */}
          <Route  path='/settings/data-repository' component={DataRepositorySetting}/>
          <Route path='/settings/logs' component={LogsSetting}/>
          <Route path='/settings/app-settings' component={ApplicationSetting}/>
          <Route path='/settings/cron' component={CroneSetting}/>
          <Route path='/settings/hooks' component={HookSetting}/>
          <Route path='/settings/references' component={ReferencesSetting}/>
          <Route path='/settings/import-export' component={ImportExportSetting}/>
          <Route path='/settings/clean-reprocess' component={CleanReprocessSetting}/>
          <Route path='/settings/maker-checker' component={MakerCheckerSetting}/>

          <Redirect from='/settings' to='/settings/groups' />
        </Switch>}
        />
    );
  }
}

export default (SettingPage);
